export default __webpack_public_path__ + "static/media/char_head_prem_018.4b79a964.png";